import React, { useMemo } from "react";
import LoadingSpinner from "../../../../externalComponents/LoadingSpinner";
import { Text } from "../../../../externalComponents/tailwind/text";
import KeyValueList from "../../../../externalComponents/KeyValueList";

export default function ContactInformationsCustomProperties({
  data,
  fetching,
}) {
  const customProperties = useMemo(() => {
    if (!data) {
      return null;
    }
    const _result = Object.fromEntries(
      Object.entries(data).filter(([key]) => key !== ""),
    );

    return Object.keys(_result || {}).length ? _result : null;
  }, [data]);

  return (
    <>
      <Text className="font-bold mt-5 mb-3">Custom properties</Text>
      {fetching ? (
        <LoadingSpinner />
      ) : customProperties ? (
        <>
          <KeyValueList data={customProperties} sort />
        </>
      ) : (
        <div className="text-gray-400 text-xs font-medium">
          No custom properties found
        </div>
      )}
    </>
  );
}
